(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hn-mobile-product-pages')) {
    customElements.define('hn-mobile-product-pages', class extends HTMLElement {
      connectedCallback() {
        this.connectionFrame = requestAnimationFrame(() => this.connect());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.connectionFrame);
        cancelAnimationFrame(this.scrollFrame);
        this.events?.abort();
        this.resizeObserver?.disconnect();
        this.panelObserver?.disconnect();
        if (this.cards) this.restoreCards();
        this.removeAttribute('data-mobile-active');
      }

      connect() {
        this.slider = this.querySelector('slider-element');
        this.grid = this.slider?.querySelector('.card-grid');
        this.controls = this.querySelector('.hn-mobile-pages__controls');
        this.previousButton = this.querySelector('[data-hn-page-previous]');
        this.nextButton = this.querySelector('[data-hn-page-next]');
        this.counter = this.querySelector('[data-hn-page-count]');
        if (!this.grid || !this.controls || !this.counter) return;

        this.cards = Array.from(this.grid.children).filter(card => card.matches('.card'));
        if (!this.cards.length) return;

        this.originalAccessibility = this.cards.map(card => ({
          inert: card.inert,
          hidden: card.getAttribute('aria-hidden')
        }));
        this.originalTabindex = this.slider.getAttribute('tabindex');
        this.pageCount = Math.ceil(Math.min(this.cards.length, 8) / 4);
        this.page = 0;
        this.events = new AbortController();
        const signal = this.events.signal;
        this.media = matchMedia('(max-width: 767px)');
        this.setAttribute('data-pages', String(this.pageCount));

        this.previousButton.addEventListener('click', () => this.goTo(this.page - 1), { signal });
        this.nextButton.addEventListener('click', () => this.goTo(this.page + 1), { signal });
        this.slider.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.updateFromScroll());
        }, { passive: true, signal });
        this.slider.addEventListener('pointerdown', () => { this.requestedPage = null; }, { passive: true, signal });
        this.slider.addEventListener('wheel', () => { this.requestedPage = null; }, { passive: true, signal });
        this.slider.addEventListener('keydown', event => {
          if (!this.media.matches || event.target !== this.slider) return;
          const forward = getComputedStyle(this.slider).direction === 'rtl' ? 'ArrowLeft' : 'ArrowRight';
          const back = forward === 'ArrowRight' ? 'ArrowLeft' : 'ArrowRight';
          if (![forward, back, 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home') this.goTo(0);
          else if (event.key === 'End') this.goTo(this.pageCount - 1);
          else this.goTo(this.page + (event.key === forward ? 1 : -1));
        }, { signal });
        this.media.addEventListener('change', () => this.refresh(), { signal });

        const panel = this.closest('[role="tabpanel"]');
        if (panel) {
          this.panelObserver = new MutationObserver(() => {
            if (!panel.hidden && this.media.matches) this.goTo(0, false);
          });
          this.panelObserver.observe(panel, { attributes: true, attributeFilter: ['hidden'] });
        }

        this.resizeObserver = new ResizeObserver(entries => {
          const width = entries[0].contentRect.width;
          if (!width || width === this.lastWidth) return;
          this.lastWidth = width;
          if (this.media.matches) this.goTo(this.page, false);
        });
        this.resizeObserver.observe(this.slider);
        this.refresh();
      }

      refresh() {
        this.page = 0;
        this.toggleAttribute('data-mobile-active', this.media.matches);
        this.controls.hidden = !this.media.matches || this.pageCount < 2;
        if (this.media.matches) {
          this.slider.setAttribute('tabindex', '0');
          this.goTo(0, false);
        } else {
          this.restoreCards();
          if (this.originalTabindex === null) this.slider.removeAttribute('tabindex');
          else this.slider.setAttribute('tabindex', this.originalTabindex);
          this.slider.scrollTo({ left: 0, behavior: 'instant' });
          this.slider.reset?.();
          this.slider.update?.();
          this.slider.updateTabindex?.();
        }
      }

      get stride() {
        return this.cards[4] ? Math.abs(this.cards[4].offsetLeft - this.cards[0].offsetLeft) : 0;
      }

      goTo(page, smooth = true) {
        if (!this.media.matches) return;
        this.page = Math.max(0, Math.min(page, this.pageCount - 1));
        this.requestedPage = this.page;
        const direction = getComputedStyle(this.slider).direction === 'rtl' ? -1 : 1;
        this.slider.scrollTo({
          left: this.page * this.stride * direction,
          behavior: smooth && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant'
        });
        this.renderState();
      }

      updateFromScroll() {
        if (!this.media.matches || !this.stride) return;
        if (this.requestedPage !== null && this.requestedPage !== undefined) {
          if (Math.abs(Math.abs(this.slider.scrollLeft) - this.requestedPage * this.stride) > 1) return;
          this.requestedPage = null;
        }
        this.page = Math.max(0, Math.min(Math.round(Math.abs(this.slider.scrollLeft) / this.stride), this.pageCount - 1));
        this.renderState();
      }

      renderState() {
        const value = String(this.page + 1) + ' / ' + String(this.pageCount);
        if (this.counter.textContent !== value) {
          this.counter.textContent = value;
          this.counter.setAttribute('aria-label', this.counter.dataset.pageLabel.replace('__HN_PAGE__', value));
        }
        this.previousButton.disabled = this.page === 0;
        this.nextButton.disabled = this.page === this.pageCount - 1;
        this.cards.forEach((card, index) => {
          const available = index < 8 && Math.floor(index / 4) === this.page;
          const original = this.originalAccessibility[index];
          card.inert = !available || original.inert;
          if (!available) card.setAttribute('aria-hidden', 'true');
          else if (original.hidden === null) card.removeAttribute('aria-hidden');
          else card.setAttribute('aria-hidden', original.hidden);
        });
      }

      restoreCards() {
        this.cards.forEach((card, index) => {
          const original = this.originalAccessibility[index];
          card.inert = original.inert;
          if (original.hidden === null) card.removeAttribute('aria-hidden');
          else card.setAttribute('aria-hidden', original.hidden);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help-drawer"]) return;
  try {
    
if (!customElements.get('hn-product-help')) {
  customElements.define('hn-product-help', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const result = this.querySelector('[data-hn-help-result]');
      if (!result) return;
      customElements.whenDefined('drawer-element').then(() => {
        const drawer = this.closest('drawer-element');
        if (!drawer || typeof drawer.show !== 'function') return;
        Promise.resolve(drawer.show(null, false)).then(() => result.focus({preventScroll:true}));
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hn-brand-trust"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hn-community-carousel')) {
  customElements.define('hn-community-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.viewport = this.querySelector('.hn-trust__viewport');
      this.track = this.querySelector('.hn-trust__photos');
      this.originals = [...this.track.children];
      this.count = this.originals.length;
      if (this.count < 2) return;
      const duplicate = (node) => {
        const clone = node.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.dataset.clone = 'true';
        return clone;
      };
      this.track.prepend(...this.originals.map(duplicate));
      this.track.append(...this.originals.map(duplicate));
      this.slides = [...this.track.children];
      this.index = this.count + Math.min(2, this.count - 1);
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.visible = false;
      this.hovered = false;
      this.focused = false;
      this.moving = false;
      this.startX = null;
      this.render(false);
      this.resize = new ResizeObserver(() => this.render(false));
      this.resize.observe(this.viewport);
      this.observer = new IntersectionObserver(([entry]) => {
        this.visible = entry.isIntersecting;
        this.schedule();
      }, { threshold: 0.15 });
      this.observer.observe(this);
      this.track.addEventListener('transitionend', (event) => {
        if (event.target === this.track && event.propertyName === 'transform') this.settle();
      }, options);
      this.viewport.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse') return;
        this.hovered = true;
        this.schedule();
      }, options);
      this.viewport.addEventListener('pointerleave', () => {
        this.hovered = false;
        this.schedule();
      }, options);
      this.addEventListener('pointerdown', () => {
        this.focused = false;
        this.schedule();
      }, options);
      this.addEventListener('focusin', (event) => {
        this.focused = event.target.matches(':focus-visible');
        this.schedule();
      }, options);
      this.addEventListener('focusout', (event) => {
        this.focused = this.contains(event.relatedTarget) && event.relatedTarget.matches(':focus-visible');
        this.schedule();
      }, options);
      this.addEventListener('keydown', (event) => {
        this.focused = true;
        this.schedule();
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, options);
      this.viewport.addEventListener('pointerdown', (event) => {
        this.startX = event.clientX;
      }, options);
      this.viewport.addEventListener('pointerup', (event) => {
        if (this.startX === null) return;
        const delta = event.clientX - this.startX;
        if (Math.abs(delta) > 35) this.move(delta < 0 ? 1 : -1);
        this.startX = null;
      }, options);
      this.viewport.addEventListener('pointercancel', () => { this.startX = null; }, options);
      this.viewport.addEventListener('dragstart', (event) => event.preventDefault(), options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => {
        this.paused = this.motion.matches;
        this.schedule();
      }, options);
      this.dataset.ready = 'true';
    }
    active() { return ((this.index - this.count) % this.count + this.count) % this.count; }
    render(animate) {
      if (!this.slides) return;
      const slide = this.slides[this.index];
      const offset = this.viewport.clientWidth / 2 - slide.offsetLeft - slide.offsetWidth / 2;
      this.track.style.transition = animate && !this.motion.matches ? '' : 'none';
      this.track.style.transform = `translate3d(${offset}px,0,0)`;
      this.slides.forEach((photo, index) => photo.classList.toggle('is-center', index === this.index));
      this.dataset.activeIndex = String(this.active() + 1);
    }
    move(delta) {
      if (this.moving || !delta) return;
      this.moving = true;
      this.index += delta;
      this.render(true);
      clearTimeout(this.settleTimer);
      this.settleTimer = setTimeout(() => this.settle(), this.motion.matches ? 0 : 720);
      this.schedule();
    }
    settle() {
      clearTimeout(this.settleTimer);
      if (this.index >= this.count * 2) this.index -= this.count;
      if (this.index < this.count) this.index += this.count;
      this.render(false);
      this.moving = false;
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.paused || !this.visible || this.hovered || this.focused || document.hidden) return;
      this.timer = setTimeout(() => this.move(1), 3000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      clearTimeout(this.settleTimer);
      this.resize?.disconnect();
      this.observer?.disconnect();
      this.controller?.abort();
      this.track?.querySelectorAll('[data-clone]').forEach((node) => node.remove());
      this.controller = null;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hn-halloween-campaign"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hn-halloween-campaign')) {
    customElements.define('hn-halloween-campaign', class extends HTMLElement {
      connectedCallback() {
        if (this.onCampaignClick) return;
        this.copyTimers = new Set();
        this.lightTimers = new Set();
        this.onLightPointerMove = (event) => {
          const stage = event.currentTarget;
          if (!(stage instanceof HTMLElement) || stage.classList.contains('is-lighting') || stage.classList.contains('is-lit')) return;
          const bounds = stage.getBoundingClientRect();
          if (!bounds.width || !bounds.height) return;
          const x = Math.max(7, Math.min(93, ((event.clientX - bounds.left) / bounds.width) * 100));
          const y = Math.max(8, Math.min(91, ((event.clientY - bounds.top) / bounds.height) * 100));
          stage.style.setProperty('--hn-light-x', `${x.toFixed(2)}%`);
          stage.style.setProperty('--hn-light-y', `${y.toFixed(2)}%`);
          stage.classList.add('is-exploring');
        };
        this.onLightPointerLeave = (event) => {
          const stage = event.currentTarget;
          if (!(stage instanceof HTMLElement) || stage.classList.contains('is-lighting') || stage.classList.contains('is-lit')) return;
          stage.classList.remove('is-exploring');
          stage.style.removeProperty('--hn-light-x');
          stage.style.removeProperty('--hn-light-y');
        };
        this.lightStages = [...this.querySelectorAll('[data-light-stage]')];
        this.lightStages.forEach((stage) => {
          stage.addEventListener('pointerdown', this.onLightPointerMove, { passive: true });
          stage.addEventListener('pointermove', this.onLightPointerMove, { passive: true });
          stage.addEventListener('pointerleave', this.onLightPointerLeave);
        });
        this.onCampaignClick = (event) => {
          const target = event.target instanceof Element ? event.target : event.target.parentElement;
          if (!target) return;
          const copy = target.closest('[data-copy-code]');
          if (copy && this.contains(copy)) { this.copyCode(copy); return; }
          const lightToggle = target.closest('[data-light-toggle]');
          if (lightToggle && this.contains(lightToggle)) { this.toggleLights(lightToggle); return; }
          const anchor = target.closest('[data-campaign-anchor]');
          if (!anchor || !this.contains(anchor)) return;
          const destination = this.querySelector('.hn-halloween-campaign__offers');
          if (!destination) return;
          event.preventDefault();
          destination.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
          destination.focus({ preventScroll: true });
        };
        this.addEventListener('click', this.onCampaignClick);
      }
      toggleLights(button) {
        if (button.getAttribute('aria-pressed') === 'true') return;
        const section = button.closest('.hn-halloween-campaign__light');
        const stage = button.closest('[data-light-stage]');
        const cta = stage?.querySelector('[data-light-cta]');
        const status = section?.querySelector('[data-light-status]');
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!stage || !cta) return;
        button.setAttribute('aria-pressed', 'true');
        stage.classList.add('is-lighting');
        if (status) status.textContent = button.dataset.lightStatusLit;
        const finish = () => {
          stage.classList.remove('is-lighting');
          stage.classList.remove('is-exploring');
          stage.classList.add('is-lit');
          button.tabIndex = -1;
          button.setAttribute('aria-hidden', 'true');
          cta.removeAttribute('tabindex');
          cta.setAttribute('aria-hidden', 'false');
          cta.focus({ preventScroll: true });
        };
        if (reduceMotion) { finish(); return; }
        const timer = window.setTimeout(() => {
          finish();
          this.lightTimers.delete(timer);
        }, 1200);
        this.lightTimers.add(timer);
      }
      async copyCode(button) {
        if (button.dataset.copying === 'true') return;
        const label = button.querySelector('[data-copy-label]');
        const status = this.querySelector('[data-copy-status]');
        const originalLabel = label.textContent;
        button.dataset.copyOriginal = originalLabel;
        button.dataset.copying = 'true';
        try {
          await navigator.clipboard.writeText(button.dataset.copyCode);
          label.textContent = button.dataset.copySuccess;
          if (status) status.textContent = `${button.dataset.copyCode} — ${button.dataset.copySuccess}`;
        } catch (error) {
          const range = document.createRange();
          range.selectNodeContents(button.querySelector('.hn-halloween-campaign__code'));
          const selection = window.getSelection();
          if (selection) { selection.removeAllRanges(); selection.addRange(range); }
          label.textContent = button.dataset.copyError;
          if (status) status.textContent = `${button.dataset.copyCode} — ${button.dataset.copyError}`;
        }
        const timer = window.setTimeout(() => {
          label.textContent = originalLabel;
          delete button.dataset.copying;
          this.copyTimers.delete(timer);
        }, 2400);
        this.copyTimers.add(timer);
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onCampaignClick);
        this.lightStages?.forEach((stage) => {
          stage.removeEventListener('pointerdown', this.onLightPointerMove);
          stage.removeEventListener('pointermove', this.onLightPointerMove);
          stage.removeEventListener('pointerleave', this.onLightPointerLeave);
        });
        this.copyTimers?.forEach((timer) => window.clearTimeout(timer));
        this.lightTimers?.forEach((timer) => window.clearTimeout(timer));
        this.querySelectorAll('[data-copy-code]').forEach((button) => {
          delete button.dataset.copying;
          const label = button.querySelector('[data-copy-label]');
          if (label && button.dataset.copyOriginal) label.textContent = button.dataset.copyOriginal;
        });
        this.lightStages = null;
        this.onLightPointerMove = null;
        this.onLightPointerLeave = null;
        this.onCampaignClick = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hn-product-benefit-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hn-light-switch')) {
  customElements.define('hn-light-switch', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.button = this.querySelector('button');
      this.day = this.querySelector('.hn-light__frame--day');
      this.night = this.querySelector('.hn-light__frame--night');
      this.prompt = this.querySelector('[data-light-prompt]');
      this.status = this.querySelector('[data-light-status]');
      if (!this.button || !this.day || !this.night || !this.prompt) return;
      this.initialized = true;
      this.on = false;
      this.button.hidden = false;
      this.prompt.parentElement.hidden = false;
      this.button.addEventListener('click', () => this.toggle());
    }
    disconnectedCallback() {
      this.pullAnimations?.forEach(animation => animation.cancel());
    }
    pullSwitch() {
      const knob = this.querySelector('.hn-light__knob');
      const cord = this.querySelector('.hn-light__cord');
      if (!knob?.animate || !cord?.animate || !this.prompt.parentElement.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return { peak: Promise.resolve(), finished: Promise.resolve() };
      }
      // One timeline moves the bulb AND its pointer; the cord stays anchored above.
      const steps = [[0, 0], [.28, 16], [.52, -3], [.72, 3], [.88, -1], [1, 0]];
      const options = { duration: 640, easing: 'ease-in-out' };
      this.pullAnimations = [
        knob.animate(steps.map(([offset, y]) => ({ offset, transform: `translateY(${y}px)` })), options),
        cord.animate(steps.map(([offset, y]) => ({ offset, transform: `scaleY(${1 + y / 10})` })), options),
        this.prompt.parentElement.animate(steps.map(([offset, y]) => ({ offset, transform: `translateY(calc(-50% + ${y}px))` })), options)
      ];
      let releasePeak;
      const peak = new Promise(resolve => { releasePeak = resolve; });
      const timer = setTimeout(releasePeak, 180);
      const finished = Promise.allSettled(this.pullAnimations.map(animation => animation.finished)).then(() => {
        clearTimeout(timer);
        releasePeak();
        this.pullAnimations = [];
      });
      return { peak, finished };
    }
    async toggle() {
      if (this.busy) return;
      const turnOn = !this.on;
      this.busy = true;
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      const pull = this.pullSwitch();
      try {
        const imageReady = (async () => {
        if (turnOn) {
          const img = this.night.querySelector('img');
          if (!img) throw new Error('Missing lighting image');
          if (!img.complete || !img.naturalWidth) {
            this.prompt.textContent = this.dataset.labelLoading;
            img.loading = 'eager';
            await new Promise((resolve, reject) => {
              const done = error => { clearTimeout(timer); img.removeEventListener('load', loaded); img.removeEventListener('error', failed); error ? reject(error) : resolve(); };
              const loaded = () => done();
              const failed = () => done(new Error('Lighting image unavailable'));
              const timer = setTimeout(failed, 12000);
              img.addEventListener('load', loaded, { once: true });
              img.addEventListener('error', failed, { once: true });
              if (img.complete && img.naturalWidth) done();
            });
          }
          if (img.decode) await img.decode();
        }
        })();
        await Promise.all([imageReady, pull.peak]);
        this.on = turnOn;
        this.classList.toggle('is-on', this.on);
        this.button.setAttribute('aria-pressed', String(this.on));
        this.day.setAttribute('aria-hidden', String(this.on));
        this.night.setAttribute('aria-hidden', String(!this.on));
        this.status.textContent = this.on ? this.dataset.stateOn : this.dataset.stateOff;
      } catch (_) {
        this.status.textContent = this.dataset.labelError;
      } finally {
        await pull.finished;
        const label = this.on ? this.dataset.labelOff : this.dataset.labelOn;
        this.prompt.textContent = label;
        this.button.setAttribute('aria-label', label);
        this.button.setAttribute('aria-busy', 'false');
        this.button.disabled = false;
        this.busy = false;
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hn-product-build-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hn-story-video')) {
  customElements.define('hn-story-video', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)').matches || navigator.connection?.saveData;
      this.video.muted = true;
      if (this.reduced) this.video.removeAttribute('autoplay');
      this.button.addEventListener('click', () => { this.userPaused = false; this.start(true); });
      this.video.addEventListener('play', () => {
        if (this.visible === false || document.hidden) { this.video.pause(); return; }
        this.button.hidden = true;
      });
      this.video.addEventListener('pause', () => { if (this.visible && !document.hidden) this.userPaused = true; this.button.hidden = false; });
      this.video.addEventListener('error', () => { this.button.hidden = false; });
      this.onVisibility = () => { if (document.hidden) this.video.pause(); };
      document.addEventListener('visibilitychange', this.onVisibility);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .2;
          if (this.visible && !this.reduced && !this.userPaused) this.start(false);
          else if (!this.visible) this.video.pause();
        }, { threshold: [0, .2] });
        this.observer.observe(this);
      }
    }
    start(manual) {
      if (!this.video.getAttribute('src')) {
        const adaptive = this.video.dataset.adaptiveSrc;
        const fallback = matchMedia('(max-width: 749px)').matches ? this.video.dataset.smallSrc : this.video.dataset.src;
        this.video.src = adaptive && this.video.canPlayType('application/vnd.apple.mpegurl') ? adaptive : fallback;
        this.video.load();
      }
      if (manual || !this.reduced) this.video.play().catch(() => { this.button.hidden = false; });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.video?.pause();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
